import { useEffect } from "react";
import { useSelector } from "react-redux";

import IndependentAppointmentFormFields from "./IndependentAppointmentFormFields";

function IndependentAppointmentForm({
  formik,
  loading,
  premises,
  premisesID,
  officerOptions,
  setCustomFields,
  setOfficerOptions,
}) {
  const { visitorData } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    formik.setFieldValue("premises", premisesID);
    formik.setFieldValue(
      "name",
      visitorData.firstName + " " + visitorData.lastName
    );
  }, [premisesID]);

  return (
    <IndependentAppointmentFormFields
      loading={loading}
      premises={premises}
      formikProps={formik}
      premisesID={premisesID}
      officerOptions={officerOptions}
      setCustomFields={setCustomFields}
      setOfficerOptions={setOfficerOptions}
    />
  );
}

export default IndependentAppointmentForm;
